const translations = {
  en: {
    EditWebsite: "Edit Website Link",
    About: "About",
    Headline: "Title/Position",
    WebsiteLink: "Website Link",
    WebsiteURL: "Website URL",
    AboutUs: "About Us",
    Phonenumber: "Phonenumber",
    Email: "Email",
    Location: "Location",
    DOB: "Date of Birth",
    Username: "Username",
    CompanySloganTitle: "Company Slogan Title",
    Instagram: "Enter Instagram Username",
    WhatsApp: "Enter WhatsApp Number",
    Facebook: "Enter Facebook Link",
    TikTok: "Enter TikTok Username",
    Youtube: "Enter Youtube Link",
    XTwitter: "Enter X/Twitter Link",
    LinkedIn: "Enter LinkedIn Link",
    Xing: "Enter Xing Link",
    CustomLink: "Enter Custom Link",
    UpdateProfile: "Update Profile",
    SuccesMessage: "Profile saved successfully",
    FailedMessage: "Could not save profile",
    Close: "Close",
    Save: "Save",
    Cancel: "Cancel",
    Info: "Info",
    Assistance:
      "Need anymore assistance? We can help you. Send us an email to ",
    OrderInfo: "with your order number and we will do it for you.",
    InstagramInfo: "Type your Instagram username in the text area provided.",
    WhatsAppInfo: "Type your WhatsApp phone number in the text area provided.",
    FacebookInfo:
      "Don't know how to create your Facebook social Link? We can help you. Send us an email to ",
    TikTokInfo: "Type your TikTok username in the text area provided.",
    YoutubeInfo: "Type your Youtube handle name in the text area provided.",
    XTwitterInfo: "Type your X username in the text area provided.",
    LinkedInInfo: "Type your LinkedIn username in the text area provided.",
    XingInfo: "Type your Xing username in the text area provided.",
    CustomLinkInfo: "Add any other social links people can find you here.",
    Example: "Example: 49123456789",
    CountryCode: "Make sure to include the country code.",
    NumberFormat: "Your number should not include any spaces or dashes.",
    MoreInformation:
      "We can help you with more information. Send us an email to",
    ERROR_MESSAGE_URL: "Please enter a valid URL",
    ERROR_MESSAGE_EMAIL: "Please enter a valid email address",
    ERROR_MESSAGE_PHONE:
      "Please enter a valid phone number in the format +123 456 7890",
    ALERT_MESSAGE: "Image size should be within 10MB.",
    ALERT_MESSAGE_SIZE: "Image dimensions should be within 500x500 pixels.",
    ALERT_MESSAGE_FILE_SIZE: "Image size should be within 10MB.",
    UPLOAD_IMAGE: "Please upload an image file.",
    instagram: "Please enter a Valid username for Instagram",
    whatsapp: "Please enter a Valid phone number for WhatsApp",
    tiktok: "Please enter a Valid username for TikTok",
    youtube: "Please enter a Valid channel for Youtube",
    xtwitter: "Please enter a Valid username for X",
    linkedin: "Please enter a Valid username for LinkedIn",
    xing: "Please enter a Valid username for Xing",
    ToTheShop: "To the Shop",
    ShopLink: "Shop Link",
    CouponCode: "Enter Coupon Code",
    ShopURL: "Enter Shop URL",
    ReviewUs: "Review Us",
    OpinionMatters: "Your Opinion Matters",
    GoogleReview: "Google Review Link",
    Google: "Enter Google Review Link",
    TrustPilot: "Enter TrustPilot Review Link",
    eKomi: "Enter eKomi Review Link",
    TripAdvisor: "Enter TripAdvisor Review Link",
    Yelp: "Enter Yelp! Review Link",
    Feedback: "Enter Feedback Review Link",
    Followus: "Follow us",
    Getintouch: "Get in touch",
    TrustPilotreview: "Trustpilot Review Link",
    EkomiReview: "eKomi Review Link",
    TripAdvisor: "TripAdvisor Review Link",
    YelpReview: "Yelp! Review Link",
    FeedbackReview: "Feedback Review Link",
    InstagramUsername: "Instagram Username",
    WhatsAppLink: "WhatsApp Link",
    FacebookLink: "Facebook Link",
    TiktokUsername: "TikTok Username",
    Youtubechannel: "YouTube Channel",
    XUsername: "X Username",
    LinkedInLink: "LinkedIn Link",
    XingLink: "Xing Link",
    CustomLink: "Custom Link",
    CouponDescription:
      "Give your customers a coupon code they can use on checkout.",
    ReviewInfo: "Don't know how to create your",
    ReviewInfo2: "Review Link? We can help you. Send us an email to",
    Menu: "Menu",
    Menulink: "Menu Link",
    MenuURl: "Enter Menu URL",
    RealEstate: "Discover Real Estate",
    Properties: "Properties Link",
    PropertiesURL: "Enter Properties URL",
    Appointment: "Make an Appointment",
    Appointmenttitle: "Appointment Link",
    AppointmentURL: "Appointment URL",
    ViewWebSite: "View Website",
    SaveContact: "Save Contact",
    ShareProfile: "Share Profile",
    URLCopied: "URL Copied to Clipboard",
    ProfileURL: "The profile URL has been copied to your clipboard.",
    ShareIt: "You can also share it via:",
    CopyURL: "Copy URL",
    MaximumCharacter: "The maximum character limit for",
    Is: "is",
    Characters: "characters.",
    FailedURL: "Failed to copy URL.",
    Logout: "Logout",
    SignUp: "Sign Up",
    SignUpDescription: "Sign Up to configure your Landing Page",
    FirstName: "First name",
    LastName: "Last name",
    Password: "Password",
    PasswordConfirm: "Confirm Password",
    SignUpError:
      "There was an error signing up you up please try again or contact support.",
    PasswordMismatch: "Passwords do not match",
    PasswordLength: "Password must be at least 8 characters",
    PasswordRequired: "Password is required",
    InvalidEmail: "Invalid email",
    EmailRequired: "Email is required",
    LastNameRequired: "Last name is required",
    FirstNameRequired: "First name is required",
    AccountIdMissing:
      "Account ID is missing. Please use the provided link or contact support.",
    SigningUp: "Signing Up",
    PleaseVerifyBeforeContinuing:
      "Sign Up was Successful. Please verify your email before continuing to Sing In.",
    SigningIn: "Signing In",
    SignIn: "Sign In",
    SignInDescription: "Sign In to your account",
    ErrorTitle: "Error Page",
    ErrorMessage:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorEmail: "Contact support for feedback.",
    ErrorMessage600:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorMessage1001:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorMessage1002:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorMessage1003:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    GoLoginPage: "Login",
    VerifyTitle: "Your Email Verification",
    SuccessMessageVerifyEmail: "Your email has been verified.",
    VerifyEmail: "If you haven't signed up, please contact support.",
    ResetPasswordError:
      "There was an error resetting your password, please try again or contact support.",
    ResetYourPassword: "Reset Your Password",
    ResettingPassword: "Resetting Password",
    ResetPasswordDescription: "Reset your password.",
    ResetPasswordSuccess: "Your password has been reset.",
    ForgotPasswordDescription:
      "Forgot your password? No worries, we can help you reset it.",
    ForgotPasswordError:
      "There was an error sending the reset password email, please try again or contact support.",
    ForgotPasswordSuccess: "An email was sent to you with an reset link.",
    SelectTemplate: "Select Template",
    Personal: "Personal",
    RealEstateText: "Real Estate",
    Shop: "Shop",
    Restaurant: "Restaurant",
    AppointmentText: "Appointment",
    Next: "Next",
    FailedSeoMessage:
      "Your username is already taken, please include more information to make it unique.",
    Crop: "Crop",
    Customize: "Customize",
    Button: "Button",
    BackgroundColor: "Background Color",
    ApplyColors: "Apply Colors",
    TextColor: "Text Color",
    SearchForBusiness: "Search for your business",
    EnterBusinessName: "Enter business name...",
    Searching: "Searching...",
    OrEnterManually: "Or enter Google review URL manually:",
    HowSatisfied: "How satisfied are you with our service?",
    PleaseSelect: "(Please select)",
    HowCanWeDoBetter: "How can we do better?",
    PleaseTellUs: "Please tell us, what we can do, to become better.",
    YourMessage: "Your message...",
    FirstName: "First name",
    LastName: "Last name",
    YourEmail: "Your email",
    SendReview: "Send review",
    Sending: "Sending...",
    WhyReviewMatters: "Why your review matters!",
    WhyReviewMattersText: "Your review helps us to improve our service and to help more customers like you, to find us.",
    ReviewUs: "Review us!",
    PleaseSelectPlatform: "Please select your preferred review platform and leave your review.",
    Happy: "Happy",
    Sad: "Sad",
    PleaseEnterMessage: "Please enter a message.",
    BusinessEmailNotConfigured: "Business email is not configured. Cannot send feedback.",
    ThankYouFeedback: "Thank you for your feedback!",
    FailedToSendFeedback: "Failed to send feedback. Please try again later.",
  },
  es: {
    EditWebsite: "Modificar el enlace del sitio web",
    About: "Acerca de",
    Headline: "Título/Posición",
    WebsiteLink: "Enlace del sitio web",
    WebsiteURL: "URL del sitio web",
    AboutUs: "Sobre nosotros",
    Phonenumber: "Número de teléfono",
    Email: "Correo electrónico",
    Location: "Ubicación",
    DOB: "Fecha de nacimiento",
    Username: "Nombre de usuario",
    CompanySloganTitle: "Eslogan de la empresa",
    Instagram: "Ingrese el nombre de usuario de Instagram",
    WhatsApp: "Ingrese el número de WhatsApp",
    Facebook: "Ingrese el enlace de Facebook",
    TikTok: "Ingrese el nombre de usuario de TikTok",
    Youtube: "Ingrese el enlace de YouTube",
    XTwitter: "Ingrese el enlace de X/Twitter",
    LinkedIn: "Ingrese el enlace de LinkedIn",
    Xing: "Ingrese el enlace de Xing",
    CustomLink: "Ingrese un enlace personalizado",
    UpdateProfile: "Actualizar perfil",
    SuccesMessage: "Perfil guardado con éxito",
    FailedMessage: "No se pudo guardar el perfil",
    Close: "Cerrar",
    Save: "Guardar",
    Cancel: "Cancelar",
    Info: "Información",
    Assistance:
      "¿Necesita más asistencia? Podemos ayudarle. Envíenos un correo electrónico a",
    OrderInfo: "con su número de pedido y lo haremos por usted.",
    InstagramInfo:
      "Escriba su nombre de usuario de Instagram en el área de texto proporcionada.",
    WhatsAppInfo:
      "Escriba su número de teléfono de WhatsApp en el área de texto proporcionada.",
    FacebookInfo:
      "¿No sabe cómo crear su enlace social de Facebook? Podemos ayudarle. Envíenos un correo electrónico a",
    TikTokInfo:
      "Escriba su nombre de usuario de TikTok en el área de texto proporcionada.",
    YoutubeInfo:
      "Escriba el nombre de su canal de YouTube en el área de texto proporcionada.",
    XTwitterInfo:
      "Escriba su nombre de usuario de X en el área de texto proporcionada.",
    LinkedInInfo:
      "Escriba su nombre de usuario de LinkedIn en el área de texto proporcionada",
    XingInfo:
      "Escriba su nombre de usuario de Xing en el área de texto proporcionada.",
    CustomLinkInfo:
      "Agregue aquí cualquier otro enlace social donde la gente pueda encontrarlo.",
    Example: "Ejemplo: 49123456789",
    CountryCode: "Asegúrese de incluir el código del país.",
    NumberFormat: "Su número no debe incluir espacios ni guiones.",
    MoreInformation:
      "Podemos proporcionarle más información. Envíenos un correo electrónico a",
    ERROR_MESSAGE_URL: "Por favor, ingrese una URL válida",
    ERROR_MESSAGE_EMAIL:
      "Por favor, ingrese una dirección de correo electrónico válida",
    ERROR_MESSAGE_PHONE:
      "Por favor, ingrese un número de teléfono válido en el formato +123 456 7890",
    ALERT_MESSAGE: "El tamaño de la imagen debe ser inferior a 10 MB.",
    ALERT_MESSAGE_SIZE:
      "Las dimensiones de la imagen deben ser inferiores a 500x500 píxeles.",
    ALERT_MESSAGE_FILE_SIZE:
      "El tamaño de la imagen debe ser inferior a 10 MB.",
    UPLOAD_IMAGE: "Por favor, cargue un archivo de imagen.",
    instagram: "Por favor, ingrese un nombre de usuario de Instagram válido",
    whatsapp: "Por favor, ingrese un número de teléfono de WhatsApp válido",
    tiktok: "Por favor, ingrese un nombre de usuario de TikTok válido",
    youtube: "Por favor, ingrese un canal de YouTube válido",
    xtwitter: "Por favor, ingrese un nombre de usuario de X válido",
    linkedin: "Por favor, ingrese un nombre de usuario de LinkedIn válido",
    xing: "Por favor, ingrese un nombre de usuario de Xing válido",
    ToTheShop: "A la tienda",
    ShopLink: "Enlace de la tienda",
    CouponCode: "Ingrese el código de descuento",
    ShopURL: "Ingrese la URL de la tienda",
    ReviewUs: "Evalúenos",
    OpinionMatters: "Su opinión es importante",
    GoogleReview: "Enlace de evaluación de Google",
    Google: "Ingrese el enlace de evaluación de Google",
    TrustPilot: "Ingrese el enlace de evaluación de TrustPilot",
    eKomi: "Ingrese el enlace de evaluación de eKomi",
    TripAdvisor: "Ingrese el enlace de evaluación de TripAdvisor",
    Yelp: "Ingrese el enlace de evaluación de Yelp!",
    Feedback: "Ingrese el enlace de evaluación de Feedback",
    Followus: "Síganos",
    Getintouch: "Contáctenos",
    TrustPilotreview: "Enlace de evaluación de Trustpilot",
    EkomiReview: "Enlace de evaluación de eKomi",
    TripAdvisor: "Enlace de evaluación de TripAdvisor",
    YelpReview: "Enlace de evaluación de Yelp!",
    FeedbackReview: "Enlace de evaluación de Feedback",
    InstagramUsername: "Nombre de usuario de Instagram",
    WhatsAppLink: "Enlace de WhatsApp",
    FacebookLink: "Enlace de Facebook",
    TiktokUsername: "Nombre de usuario de TikTok",
    Youtubechannel: "Canal de YouTube",
    XUsername: "Nombre de usuario de X",
    LinkedInLink: "Enlace de LinkedIn",
    XingLink: "Enlace de Xing",
    CustomLink: "Enlace personalizado",
    CouponDescription:
      "Ofrezca a sus clientes un código de descuento que pueden usar al realizar el pago.",
    ReviewInfo: "¿No sabes cómo crear tu",
    ReviewInfo2:
      "¿No sabe cómo crear su enlace de evaluación? Podemos ayudarle. Envíenos un correo electrónico a",
    Menu: "Menú",
    Menulink: "Enlace del menú",
    MenuURl: "Ingrese la URL del menú",
    RealEstate: "Descubra bienes raíces",
    Properties: "Enlace de propiedades",
    PropertiesURL: "Ingrese la URL de propiedades",
    Appointment: "Hacer una cita",
    Appointmenttitle: "Enlace de cita",
    AppointmentURL: "URL de cita",
    ViewWebSite: "Ver sitio web",
    SaveContact: "Guardar contacto",
    ShareProfile: "Compartir perfil",
    URLCopied: "URL copiada al portapapeles",
    ProfileURL: "La URL del perfil ha sido copiada a su portapapeles.",
    ShareIt: "También puede compartirlo a través de:",
    CopyURL: "Copiar URL",
    MaximumCharacter: "El límite máximo de caracteres para",
    Is: "es de",
    Characters: "caracteres.",
    FailedURL: "Error al copiar la URL",
    Logout: "Cerrar sesión",
    SignUp: "Regístrate",
    SignUpDescription: "Regístrate para configurar tu página de destino",
    FirstName: "Nombre",
    LastName: "Apellido",
    Password: "Contraseña",
    PasswordConfirm: "Confirmar Contraseña",
    SignUpError:
      "Hubo un error al registrarte, por favor intenta de nuevo o contacta al soporte.",
    PasswordMismatch: "Las contraseñas no coinciden",
    PasswordLength: "La contraseña debe tener al menos 8 caracteres",
    PasswordRequired: "Se requiere contraseña",
    InvalidEmail: "Correo electrónico inválido",
    EmailRequired: "Correo electrónico es requerido",
    LastNameRequired: "Apellido es requerido",
    FirstNameRequired: "Nombre es requerido",
    AccountIdMissing:
      "Falta el ID de la cuenta. Por favor, usa el enlace proporcionado o contacta al soporte.",
    SigningUp: "Registrándose",
    PleaseVerifyBeforeContinuing:
      "El registro fue exitoso. Por favor, verifica tu correo electrónico antes de continuar para iniciar sesión.",
    SigningIn: "Iniciando Sesión",
    SignIn: "Iniciar Sesión",
    SignInDescription: "Inicia sesión en tu cuenta",
    ErrorTitle: "Página de Error",
    ErrorMessage:
      "Se produjo un error al procesar su solicitud. Inténtelo nuevamente más tarde. Comuníquese con el servicio de asistencia si el error persiste.",
    ErrorEmail: "Contacta al soporte para comentarios.",
    ErrorMessage600:
      "Se produjo un error al procesar su solicitud. Inténtelo nuevamente más tarde. Comuníquese con el servicio de asistencia si el error persiste.",
    ErrorMessage1001:
      "Se produjo un error al procesar su solicitud. Inténtelo nuevamente más tarde. Comuníquese con el servicio de asistencia si el error persiste.",
    ErrorMessage1002:
      "Se produjo un error al procesar su solicitud. Inténtelo nuevamente más tarde. Comuníquese con el servicio de asistencia si el error persiste.",
    ErrorMessage1003:
      "Se produjo un error al procesar su solicitud. Inténtelo nuevamente más tarde. Comuníquese con el servicio de asistencia si el error persiste.",
    GoLoginPage: "Acceso",
    VerifyTitle: "Verificación de Tu Correo Electrónico",
    SuccessMessageVerifyEmail: "Tu correo electrónico ha sido verificado.",
    VerifyEmail: "Si no te has registrado, por favor contacta al soporte.",
    ResetPasswordError:
      "Hubo un error al restablecer tu contraseña, por favor intenta de nuevo o contacta al soporte.",
    ResetYourPassword: "Restablece Tu Contraseña",
    ResettingPassword: "Restableciendo Contraseña",
    ResetPasswordDescription: "Restablece tu contraseña.",
    ResetPasswordSuccess: "Tu contraseña ha sido restablecida.",
    ForgotPasswordDescription:
      "¿Olvidaste tu contraseña? No te preocupes, podemos ayudarte a restablecerla.",
    ForgotPasswordError:
      "Hubo un error al enviar el correo electrónico para restablecer la contraseña, por favor intenta de nuevo o contacta al soporte.",
    ForgotPasswordSuccess:
      "Se te ha enviado un correo electrónico con un enlace de restablecimiento.",
    SelectTemplate: "Seleccionar Plantilla",
    Personal: "Personal",
    RealEstateText: "Bienes Raíces",
    Shop: "Tienda",
    Restaurant: "Restaurante",
    AppointmentText: "Cita",
    Next: "Siguiente",
    FailedSeoMessage:
      "Tu nombre de usuario ya está en uso, por favor incluye más información para hacerlo único.",
    Crop: "Recortar",
    Customize: "Personalizar",
    Button: "Botón",
    BackgroundColor: "Color de fondo",
    ApplyColors: "Aplicar colores",
    TextColor: "Color del texto",
    SearchForBusiness: "Buscar tu negocio",
    EnterBusinessName: "Ingresa el nombre del negocio...",
    Searching: "Buscando...",
    OrEnterManually: "O ingrese la URL de evaluación de Google manualmente:",
    HowSatisfied: "¿Qué tan satisfecho está con nuestro servicio?",
    PleaseSelect: "(Por favor seleccione)",
    HowCanWeDoBetter: "¿Cómo podemos mejorar?",
    PleaseTellUs: "Por favor díganos, qué podemos hacer para mejorar.",
    YourMessage: "Tu mensaje...",
    FirstName: "Nombre",
    LastName: "Apellido",
    YourEmail: "Tu correo electrónico",
    SendReview: "Enviar reseña",
    Sending: "Enviando...",
    WhyReviewMatters: "¡Por qué tu reseña importa!",
    WhyReviewMattersText: "Tu reseña nos ayuda a mejorar nuestro servicio y a ayudar a más clientes como tú a encontrarnos.",
    ReviewUs: "¡Reséñanos!",
    PleaseSelectPlatform: "Por favor selecciona tu plataforma de reseñas preferida y deja tu reseña.",
    Happy: "Feliz",
    Sad: "Triste",
    PleaseEnterMessage: "Por favor ingrese un mensaje.",
    BusinessEmailNotConfigured: "El correo electrónico del negocio no está configurado. No se puede enviar comentarios.",
    ThankYouFeedback: "¡Gracias por tus comentarios!",
    FailedToSendFeedback: "No se pudo enviar los comentarios. Por favor, inténtelo de nuevo más tarde.",
  },
  de: {
    EditWebsite: "Webseiten Link bearbeiten",
    About: "Über",
    Headline: "Titel / Position",
    WebsiteLink: "Link zur Website",
    WebsiteURL: "Webeseiten URL",
    AboutUs: "Über uns",
    Phonenumber: "Telefonnummer",
    Email: "E-Mail",
    Location: "Ort",
    DOB: "Geburtsdatum",
    Username: "Nutzername",
    CompanySloganTitle: "Firmen Slogan",
    Instagram: "Instagram Nutzernamen eingeben",
    WhatsApp: "WhatsApp Nummer eingeben",
    Facebook: "Facebook Profil Link eingeben",
    TikTok: "TikTok Nutzernamen eingeben",
    Youtube: "Youtube Link eingeben",
    XTwitter: "X/Twitter Link eingeben",
    LinkedIn: "LinkedIn Link eingeben",
    Xing: "Xing Link eingeben",
    CustomLink: "Individueller Link",
    UpdateProfile: "Profil aktualisieren",
    SuccesMessage: "Profil erfolgreich aktualisiert.",
    FailedMessage: "Profil konnte nicht gespeichert werden.",
    Close: "Schließen",
    Save: "Speichern",
    Cancel: "Abbrechen",
    Info: "Info",
    Assistance: "Benötigst Du weitere Hilfe? Sende uns bitte eine Mail an",
    OrderInfo: "mit Deiner Bestellnummer und wir übernehmen es gerne für Dich!",
    InstagramInfo:
      "Bitte gebe Deinen Instagram Nutzernamen in dem Textfeld ein.",
    WhatsAppInfo:
      "Bitte gebe Deine WhatsApp Telefonnummer in dem Textfeld ein.",
    FacebookInfo:
      "Du weißt nicht, wie Du deinen Facebook Link erstellst? Wir helfen Dir gerne. Sende uns eine E-Mail an",
    TikTokInfo: "Bitte gebe Deinen TikTok Nutzernamen in dem Textfeld ein.",
    YoutubeInfo: "Bitte gebe Deinen Youtube Nutzernamen in dem Textfeld ein.",
    XTwitterInfo:
      "Bitte gebe Deinen X / Twitter Nutzernamen in dem Textfeld ein.",
    LinkedInInfo: "Bitte gebe Deinen LinkedIN Nutzernamen in dem Textfeld ein.",
    XingInfo: "Bitte gebe Deinen Xing Nutzernamen in dem Textfeld ein.",
    CustomLinkInfo: "Füge weitere Deiner Social Media Links hinzu",
    Example: "Beispiel: 49123456789",
    CountryCode:
      "Bitte denke daran, die richtige Ländervorwahl zu ergänzen (49 in Deutschland).",
    NumberFormat:
      "Deine Nummer darf keine Leerzeichen oder Trennstriche beinhalten.",
    MoreInformation:
      "Wir können Dir gerne weiterhelfen. Sende uns hierzu eine E-Mail.",
    ERROR_MESSAGE_URL: "Bitte gebe eine gültige URL ein.",
    ERROR_MESSAGE_EMAIL: "Bitte gebe eine gültige E-Mail ein.",
    ERROR_MESSAGE_PHONE:
      "Bitte gebe eine gültige Nummer im Format +49908899 ein.",
    ALERT_MESSAGE: "Die Bildgröße darf 10MB nicht übersteigen.",
    ALERT_MESSAGE_SIZE:
      "Die Bildabmessungen sollten 500x500 Pixel nicht übersteigen",
    ALERT_MESSAGE_FILE_SIZE: "Die Bildgröße darf 10MB nicht übersteigen.",
    UPLOAD_IMAGE: "Bitte lade ein Bild hoch.",
    instagram: "Bitte geben einen gültigen Nutzernamen an.",
    whatsapp: "Bitte gebe eine gültige WhatsApp Nummer an",
    tiktok: "Bitte geben einen gültigen Nutzernamen an.",
    youtube: "Bitte geben einen gültigen Youtube Channel an.",
    xtwitter: "Bitte geben einen gültigen Nutzernamen an.",
    linkedin: "Bitte geben einen gültigen Nutzernamen an.",
    xing: "Bitte geben einen gültigen Nutzernamen an.",
    ToTheShop: "Zum Shop",
    ShopLink: "Shop Link",
    CouponCode: "Gebe einen Gutscheincode ein.",
    ShopURL: "Gebe den Link zu Deinem Shop an.",
    ReviewUs: "Bewerte uns",
    OpinionMatters: "Deine Meinnung zählt",
    GoogleReview: "Google Bewertungslink",
    Google: "Gebe den Google Bewertungslink ein.",
    TrustPilot: "Gebe den TrustPilot Bewertungslink ein.",
    eKomi: "Gebe den ekomi Bewertungslink ein.",
    TripAdvisor: "Gebe den TripAdvisorBewertungslink ein.",
    Yelp: "Gebe den Yelp! Bewertungslink ein.",
    Feedback: "Gebe deinen individuellen Bewertungslink ein.",
    Followus: "Folge uns",
    Getintouch: "Get in touch",
    TrustPilotreview: "Trustpilot Bewertungslink",
    EkomiReview: "ekomi Bewertungslink",
    TripAdvisor: "TripAdvisor Bewertungslink",
    YelpReview: "Yelp! Bewertungslink",
    FeedbackReview: "Individueller Link",
    InstagramUsername: "Instagram Nutzername",
    WhatsAppLink: "WhatApp Nummer",
    FacebookLink: "Facebook Link",
    TiktokUsername: "TikTok Nutzername",
    Youtubechannel: "YouTube Channel",
    XUsername: "X Nutzername",
    LinkedInLink: "LinkedIn Link ",
    XingLink: "Xing Link",
    CustomLink: "Individueller Link",
    CouponDescription:
      "Gebe Deinen Kund:innen einen Gutscheincode für Deinen Shop",
    ReviewInfo: "Du weißt nicht, wie Du deinen",
    ReviewInfo2:
      "Bewertungs-Link erstellst? Wir helfen Dir gerne. Sende uns eine E-Mail an ",
    Menu: "Speisekarte",
    Menulink: "Link zur Speisekarte",
    MenuURl: "Gebe die URL zur Speisekarte ein",
    RealEstate: "Entdecke unsere Immobilienangebote",
    Properties: "Link zu den Immobilienangeboten",
    PropertiesURL: "Gebe den Link zur den Immobilienangeboten an.",
    Appointment: "Termin vereinbaren",
    Appointmenttitle: "Link zur Terminvereinbarung",
    AppointmentURL: "Link zur Terminvereinbarung",
    ViewWebSite: "Zur Website",
    SaveContact: "Kontakt speichern",
    ShareProfile: "Profil teilen",
    URLCopied: "Profil URL wurde zu Deiner Zwischenablage kopiert",
    ProfileURL: "Profil URL wurde zu Deiner Zwischenablage kopiert",
    ShareIt: "Du kannst es auch teilen via:",
    CopyURL: "URL kopieren",
    MaximumCharacter: "Die maximale Anzahl an Zeichen für",
    Is: "ist",
    Characters: "Zeichen.",
    ChooseLanguage: "Wählen Sie Ihre Sprache",
    FailedURL: "URL konnte nicht kopiert werden.",
    MaximumCharacter: "Die maximale Anzahl an Zeichen für",
    Logout: "Ausloggen",
    SignUp: "Registrieren",
    SignUpDescription:
      "Registrieren Sie sich, um Ihre Landingpage zu konfigurieren",
    FirstName: "Vorname",
    LastName: "Nachname",
    Password: "Passwort",
    PasswordConfirm: "Passwort Bestätigen",
    SignUpError:
      "Es gab einen Fehler bei der Registrierung, bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    PasswordMismatch: "Passwörter stimmen nicht überein",
    PasswordLength: "Passwort muss mindestens 8 Zeichen lang sein",
    PasswordRequired: "Passwort ist erforderlich",
    InvalidEmail: "Ungültige E-Mail",
    EmailRequired: "E-Mail ist erforderlich",
    LastNameRequired: "Nachname ist erforderlich",
    FirstNameRequired: "Vorname ist erforderlich",
    AccountIdMissing:
      "Kontonummer fehlt. Bitte verwenden Sie den bereitgestellten Link oder kontaktieren Sie den Support.",
    SigningUp: "Registrierung",
    PleaseVerifyBeforeContinuing:
      "Registrierung erfolgreich. Bitte überprüfen Sie Ihre E-Mail, bevor Sie sich anmelden.",
    SigningIn: "Anmeldung",
    SignIn: "Anmelden",
    SignInDescription: "Melden Sie sich bei Ihrem Konto an",
    ErrorTitle: "Fehlerseite",
    ErrorMessage:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorEmail: "Kontaktieren Sie den Support für Feedback.",
    ErrorMessage600:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorMessage1001:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorMessage1002:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorMessage1003:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    GoLoginPage: "Ausloggen",
    VerifyTitle: "Ihre E-Mail-Verifizierung",
    SuccessMessageVerifyEmail: "Ihre E-Mail wurde verifiziert.",
    VerifyEmail:
      "Wenn Sie sich nicht registriert haben, kontaktieren Sie bitte den Support.",
    ResetPasswordError:
      "Fehler beim Zurücksetzen Ihres Passworts, bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    ResetYourPassword: "Setzen Sie Ihr Passwort Zurück",
    ResettingPassword: "Passwort wird Zurückgesetzt",
    ResetPasswordDescription: "Setzen Sie Ihr Passwort zurück.",
    ResetPasswordSuccess: "Ihr Passwort wurde zurückgesetzt.",
    ForgotPasswordDescription:
      "Passwort vergessen? Keine Sorge, wir helfen Ihnen beim Zurücksetzen.",
    ForgotPasswordError:
      "Fehler beim Senden der Passwort-Reset-E-Mail, bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    ForgotPasswordSuccess:
      "Eine E-Mail mit einem Reset-Link wurde an Sie gesendet.",
    SelectTemplate: "Vorlage Auswählen",
    Personal: "Persönlich",
    RealEstateText: "Immobilien",
    Shop: "Geschäft",
    Restaurant: "Restaurant",
    AppointmentText: "Termin",
    Next: "Weiter",
    FailedSeoMessage:
      "Ihr Benutzername ist bereits vergeben, bitte fügen Sie weitere Informationen hinzu, um ihn einzigartig zu machen.",
    Crop: "Zuschneiden",
    Customize: "Anpassen",
    Button: "Taste",
    BackgroundColor: "Hintergrundfarbe",
    ApplyColors: "Farben anwenden",
    TextColor: "Textfarbe",
    SearchForBusiness: "Suchen Sie Ihr Unternehmen",
    EnterBusinessName: "Geben Sie den Firmennamen ein...",
    Searching: "Suchen...",
    OrEnterManually: "Oder geben Sie die Google-Bewertungs-URL manuell ein:",
    HowSatisfied: "Wie zufrieden sind Sie mit unserem Service?",
    PleaseSelect: "(Bitte auswählen)",
    HowCanWeDoBetter: "Wie können wir besser werden?",
    PleaseTellUs: "Bitte sagen Sie uns, was wir tun können, um besser zu werden.",
    YourMessage: "Ihre Nachricht...",
    FirstName: "Vorname",
    LastName: "Nachname",
    YourEmail: "Ihre E-Mail",
    SendReview: "Bewertung senden",
    Sending: "Senden...",
    WhyReviewMatters: "Warum Ihre Bewertung wichtig ist!",
    WhyReviewMattersText: "Ihre Bewertung hilft uns, unseren Service zu verbessern und mehr Kunden wie Ihnen zu helfen, uns zu finden.",
    ReviewUs: "Bewerten Sie uns!",
    PleaseSelectPlatform: "Bitte wählen Sie Ihre bevorzugte Bewertungsplattform und hinterlassen Sie Ihre Bewertung.",
    Happy: "Zufrieden",
    Sad: "Unzufrieden",
    PleaseEnterMessage: "Bitte geben Sie eine Nachricht ein.",
    BusinessEmailNotConfigured: "Die geschäftliche E-Mail-Adresse ist nicht konfiguriert. Feedback kann nicht gesendet werden.",
    ThankYouFeedback: "Vielen Dank für Ihr Feedback!",
    FailedToSendFeedback: "Fehler beim Senden des Feedbacks. Bitte versuchen Sie es später erneut.",
  },
  eng: {
    EditWebsite: "Edit Website Link",
    About: "About",
    Headline: "Title/Position",
    WebsiteLink: "Website Link",
    WebsiteURL: "Website URL",
    AboutUs: "About Us",
    Phonenumber: "Phonenumber",
    Email: "Email",
    Location: "Location",
    DOB: "Date of Birth",
    Username: "Username",
    CompanySloganTitle: "Company Slogan Title",
    Instagram: "Enter Instagram Username",
    WhatsApp: "Enter WhatsApp Number",
    Facebook: "Enter Facebook Link",
    TikTok: "Enter TikTok Username",
    Youtube: "Enter Youtube Link",
    XTwitter: "Enter X/Twitter Link",
    LinkedIn: "Enter LinkedIn Link",
    Xing: "Enter Xing Link",
    CustomLink: "Enter Custom Link",
    UpdateProfile: "Update Profile",
    SuccesMessage: "Profile saved successfully",
    FailedMessage: "Could not save profile",
    Close: "Close",
    Save: "Save",
    Cancel: "Cancel",
    Info: "Info",
    Assistance:
      "Need anymore assistance? We can help you. Send us an email to ",
    OrderInfo: "with your order number and we will do it for you.",
    InstagramInfo: "Type your Instagram username in the text area provided.",
    WhatsAppInfo: "Type your WhatsApp phone number in the text area provided.",
    FacebookInfo:
      "Don't know how to create your Facebook social Link? We can help you. Send us an email to ",
    TikTokInfo: "Type your TikTok username in the text area provided.",
    YoutubeInfo: "Type your Youtube handle name in the text area provided.",
    XTwitterInfo: "Type your X username in the text area provided.",
    LinkedInInfo: "Type your LinkedIn username in the text area provided.",
    XingInfo: "Type your Xing username in the text area provided.",
    CustomLinkInfo: "Add any other social links people can find you here.",
    Example: "Example: 49123456789",
    CountryCode: "Make sure to include the country code.",
    NumberFormat: "Your number should not include any spaces or dashes.",
    MoreInformation:
      "We can help you with more information. Send us an email to",
    ERROR_MESSAGE_URL: "Please enter a valid URL",
    ERROR_MESSAGE_EMAIL: "Please enter a valid email address",
    ERROR_MESSAGE_PHONE:
      "Please enter a valid phone number in the format +123 456 7890",
    ALERT_MESSAGE: "Image size should be within 10MB.",
    ALERT_MESSAGE_SIZE: "Image dimensions should be within 500x500 pixels.",
    ALERT_MESSAGE_FILE_SIZE: "Image size should be within 10MB.",
    UPLOAD_IMAGE: "Please upload an image file.",
    instagram: "Please enter a Valid username for Instagram",
    whatsapp: "Please enter a Valid phone number for WhatsApp",
    tiktok: "Please enter a Valid username for TikTok",
    youtube: "Please enter a Valid channel for Youtube",
    xtwitter: "Please enter a Valid username for X",
    linkedin: "Please enter a Valid username for LinkedIn",
    xing: "Please enter a Valid username for Xing",
    ToTheShop: "To the Shop",
    ShopLink: "Shop Link",
    CouponCode: "Enter Coupon Code",
    ShopURL: "Enter Shop URL",
    ReviewUs: "Review Us",
    OpinionMatters: "Your Opinion Matters",
    GoogleReview: "Google Review Link",
    Google: "Enter Google Review Link",
    TrustPilot: "Enter TrustPilot Review Link",
    eKomi: "Enter eKomi Review Link",
    TripAdvisor: "Enter TripAdvisor Review Link",
    Yelp: "Enter Yelp! Review Link",
    Feedback: "Enter Feedback Review Link",
    Followus: "Follow us",
    Getintouch: "Get in touch",
    TrustPilotreview: "Trustpilot Review Link",
    EkomiReview: "eKomi Review Link",
    TripAdvisor: "TripAdvisor Review Link",
    YelpReview: "Yelp! Review Link",
    FeedbackReview: "Feedback Review Link",
    InstagramUsername: "Instagram Username",
    WhatsAppLink: "WhatsApp Link",
    FacebookLink: "Facebook Link",
    TiktokUsername: "TikTok Username",
    Youtubechannel: "YouTube Channel",
    XUsername: "X Username",
    LinkedInLink: "LinkedIn Link",
    XingLink: "Xing Link",
    CustomLink: "Custom Link",
    CouponDescription:
      "Give your customers a coupon code they can use on checkout.",
    ReviewInfo: "Don't know how to create your",
    ReviewInfo2: "Review Link? We can help you. Send us an email to",
    Menu: "Menu",
    Menulink: "Menu Link",
    MenuURl: "Enter Menu URL",
    RealEstate: "Discover Real Estate",
    Properties: "Properties Link",
    PropertiesURL: "Enter Properties URL",
    Appointment: "Make an Appointment",
    Appointmenttitle: "Appointment Link",
    AppointmentURL: "Appointment URL",
    ViewWebSite: "View Website",
    SaveContact: "Save Contact",
    ShareProfile: "Share Profile",
    URLCopied: "URL Copied to Clipboard",
    ProfileURL: "The profile URL has been copied to your clipboard.",
    ShareIt: "You can also share it via:",
    CopyURL: "Copy URL",
    MaximumCharacter: "The maximum character limit for",
    Is: "is",
    Characters: "characters.",
    FailedURL: "Failed to copy URL.",
    Logout: "Logout",
    SignUp: "Sign Up",
    SignUpDescription: "Sign Up to configure your Landing Page",
    FirstName: "First name",
    LastName: "Last name",
    Password: "Password",
    PasswordConfirm: "Confirm Password",
    SignUpError:
      "There was an error signing up you up please try again or contact support.",
    PasswordMismatch: "Passwords do not match",
    PasswordLength: "Password must be at least 8 characters",
    PasswordRequired: "Password is required",
    InvalidEmail: "Invalid email",
    EmailRequired: "Email is required",
    LastNameRequired: "Last name is required",
    FirstNameRequired: "First name is required",
    AccountIdMissing:
      "Account ID is missing. Please use the provided link or contact support.",
    SigningUp: "Signing Up",
    PleaseVerifyBeforeContinuing:
      "Sign Up was Successful. Please verify your email before continuing to Sing In.",
    SigningIn: "Signing In",
    SignIn: "Sign In",
    SignInDescription: "Sign In to your account",
    ErrorTitle: "Error Page",
    ErrorMessage:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorEmail: "Contact support for feedback.",
    ErrorMessage600:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorMessage1001:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorMessage1002:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    ErrorMessage1003:
      "An error occurred while processing your request. Please try again later. Contact support if the error persists.",
    GoLoginPage: "Login",
    VerifyTitle: "Your Email Verification",
    SuccessMessageVerifyEmail: "Your email has been verified.",
    VerifyEmail: "If you haven't signed up, please contact support.",
    ResetPasswordError:
      "There was an error resetting your password, please try again or contact support.",
    ResetYourPassword: "Reset Your Password",
    ResettingPassword: "Resetting Password",
    ResetPasswordDescription: "Reset your password.",
    ResetPasswordSuccess: "Your password has been reset.",
    ForgotPasswordDescription:
      "Forgot your password? No worries, we can help you reset it.",
    ForgotPasswordError:
      "There was an error sending the reset password email, please try again or contact support.",
    ForgotPasswordSuccess: "An email was sent to you with an reset link.",
    SelectTemplate: "Select Template",
    Personal: "Personal",
    RealEstateText: "Real Estate",
    Shop: "Shop",
    Restaurant: "Restaurant",
    AppointmentText: "Appointment",
    Next: "Next",
    FailedSeoMessage:
      "Your username is already taken, please include more information to make it unique.",
    Crop: "Crop",
    Customize: "Customize",
    Button: "Button",
    BackgroundColor: "Background Color",
    ApplyColors: "Apply Colors",
    TextColor: "Text Color",
    SearchForBusiness: "Search for your business",
    EnterBusinessName: "Enter business name...",
    Searching: "Searching...",
    OrEnterManually: "Or enter Google review URL manually:",
    HowSatisfied: "How satisfied are you with our service?",
    PleaseSelect: "(Please select)",
    HowCanWeDoBetter: "How can we do better?",
    PleaseTellUs: "Please tell us, what we can do, to become better.",
    YourMessage: "Your message...",
    FirstName: "First name",
    LastName: "Last name",
    YourEmail: "Your email",
    SendReview: "Send review",
    Sending: "Sending...",
    WhyReviewMatters: "Why your review matters!",
    WhyReviewMattersText: "Your review helps us to improve our service and to help more customers like you, to find us.",
    ReviewUs: "Review us!",
    PleaseSelectPlatform: "Please select your preferred review platform and leave your review.",
    Happy: "Happy",
    Sad: "Sad",
    PleaseEnterMessage: "Please enter a message.",
    BusinessEmailNotConfigured: "Business email is not configured. Cannot send feedback.",
    ThankYouFeedback: "Thank you for your feedback!",
    FailedToSendFeedback: "Failed to send feedback. Please try again later.",
  },
  fr: {
    EditWebsite: "Modifier le lien du site Web",
    About: "À propos",
    Headline: "Titre/Position",
    WebsiteLink: "Lien du site Web",
    WebsiteURL: "URL du site Web",
    AboutUs: "À propos de nous",
    Phonenumber: "Numéro de téléphone",
    Email: "E-mail",
    Location: "Localisation",
    DOB: "Date de naissance",
    Username: "Nom d'utilisateur",
    CompanySloganTitle: "Slogan de l'entreprise",
    Instagram: "Entrez le nom d'utilisateur Instagram",
    WhatsApp: "Entrez le numéro WhatsApp",
    Facebook: "Entrez le lien Facebook",
    TikTok: "Entrez le nom d'utilisateur TikTok",
    Youtube: "Entrez le lien YouTube",
    XTwitter: "Entrez le lien X/Twitter",
    LinkedIn: "Entrez le lien LinkedIn",
    Xing: "Entrez le lien Xing",
    CustomLink: "Entrez un lien personnalisé",
    UpdateProfile: "Mettre à jour le profil",
    SuccesMessage: "Profil enregistré avec succès",
    FailedMessage: "Impossible d'enregistrer le profil",
    Close: "Fermer",
    Save: "Enregistrer",
    Cancel: "Annuler",
    Info: "Info",
    Assistance:
      "Besoin de plus d'assistance ? Nous pouvons vous aider. Envoyez-nous un e-mail à",
    OrderInfo: "avec votre numéro de commande et nous le ferons pour vous.",
    InstagramInfo:
      "Tapez votre nom d'utilisateur Instagram dans la zone de texte fournie.",
    WhatsAppInfo:
      "Tapez votre numéro de téléphone WhatsApp dans la zone de texte fournie.",
    FacebookInfo:
      "Vous ne savez pas comment créer votre lien social Facebook ? Nous pouvons vous aider. Envoyez-nous un e-mail à ",
    TikTokInfo:
      "Tapez votre nom d'utilisateur TikTok dans la zone de texte fournie.",
    YoutubeInfo:
      "Tapez le nom de votre chaîne YouTube dans la zone de texte fournie.",
    XTwitterInfo:
      "Tapez votre nom d'utilisateur X dans la zone de texte fournie.",
    LinkedInInfo:
      "Tapez votre nom d'utilisateur LinkedIn dans la zone de texte fournie.",
    XingInfo:
      "Tapez votre nom d'utilisateur Xing dans la zone de texte fournie.",
    CustomLinkInfo:
      "Ajoutez ici tout autre lien social où les gens peuvent vous trouver.",
    Example: "Exemple: 49123456789",
    CountryCode: "Assurez-vous d'inclure l'indicatif du pays.",
    NumberFormat: "Votre numéro ne doit pas inclure d'espaces ni de tirets.",
    MoreInformation:
      "Nous pouvons vous fournir plus d'informations. Envoyez-nous un e-mail à",
    ERROR_MESSAGE_URL: "Veuillez entrer une URL valide",
    ERROR_MESSAGE_EMAIL: "Veuillez entrer une adresse e-mail valide",
    ERROR_MESSAGE_PHONE:
      "Veuillez entrer un numéro de téléphone valide au format +123 456 7890",
    ALERT_MESSAGE: "La taille de l'image doit être inférieure à 10 Mo.",
    ALERT_MESSAGE_SIZE:
      "Les dimensions de l'image doivent être inférieures à 500x500 pixels",
    ALERT_MESSAGE_FILE_SIZE:
      "La taille de l'image doit être inférieure à 10 Mo.",
    UPLOAD_IMAGE: "Veuillez télécharger un fichier image.",
    instagram: "Veuillez entrer un nom d'utilisateur Instagram valide",
    whatsapp: "Veuillez entrer un numéro de téléphone WhatsApp valide",
    tiktok: "Veuillez entrer un nom d'utilisateur TikTok valide",
    youtube: "Veuillez entrer une chaîne YouTube valide",
    xtwitter: "Veuillez entrer un nom d'utilisateur X valide",
    linkedin: "Veuillez entrer un nom d'utilisateur LinkedIn valide",
    xing: "Veuillez entrer un nom d'utilisateur Xing valide",
    ToTheShop: "Vers la boutique",
    ShopLink: "Lien de la boutique",
    CouponCode: "Entrez le code de réduction",
    ShopURL: "Entrez l'URL de la boutique",
    ReviewUs: "Évaluez-nous",
    OpinionMatters: "Votre opinion compte",
    GoogleReview: "Lien d'évaluation Google",
    Google: "Entrez le lien d'évaluation Google",
    TrustPilot: "Entrez le lien d'évaluation TrustPilot",
    eKomi: "Entrez le lien d'évaluation eKomi",
    TripAdvisor: "Entrez le lien d'évaluation TripAdvisor",
    Yelp: "Entrez le lien d'évaluation Yelp!",
    Feedback: "Entrez le lien d'évaluation Feedback",
    Followus: "Suivez-nous",
    Getintouch: "Contactez-nous",
    TrustPilotreview: "Lien d'évaluation Trustpilot",
    EkomiReview: "Lien d'évaluation eKomi",
    TripAdvisor: "Lien d'évaluation TripAdvisor",
    YelpReview: "Lien d'évaluation Yelp!",
    FeedbackReview: "Lien d'évaluation Feedback",
    InstagramUsername: "Nom d'utilisateur Instagram",
    WhatsAppLink: "Lien WhatsApp",
    FacebookLink: "Lien Facebook",
    TiktokUsername: "Nom d'utilisateur TikTok",
    Youtubechannel: "Chaîne YouTube",
    XUsername: "Nom d'utilisateur X",
    LinkedInLink: "Lien LinkedIn",
    XingLink: "Lien Xing",
    CustomLink: "Lien personnalisé",
    CouponDescription:
      "Offrez à vos clients un code de réduction qu'ils peuvent utiliser lors de la validation.",
    ReviewInfo: "Vous ne savez pas comment créer votre",
    ReviewInfo2:
      "lien d'évaluation ? Nous pouvons vous aider. Envoyez-nous un e-mail à",
    Menu: "Menu",
    Menulink: "Lien du menu",
    MenuURl: "Entrez l'URL du menu",
    RealEstate: "Découvrez l'immobilier",
    Properties: "Lien des propriétés",
    PropertiesURL: "Entrez l'URL des propriétés",
    Appointment: "Prendre rendez-vous",
    Appointmenttitle: "Lien de rendez-vous",
    AppointmentURL: "URL de rendez-vous",
    ViewWebSite: "Voir le site Web",
    SaveContact: "Enregistrer le contact",
    ShareProfile: "Partager le profil",
    URLCopied: "URL copiée dans le presse-papiers",
    ProfileURL: "L'URL du profil a été copiée dans votre presse-papiers.",
    ShareIt: "Vous pouvez également le partager via:",
    CopyURL: "Copier l'URL",
    MaximumCharacter: "Le nombre maximum de caractères pour",
    Is: "est de",
    Characters: "caractères.",
    FailedURL: "Échec de la copie de l'URL",
    Logout: "Se déconnecter",
    SignUp: "S'inscrire",
    SignUpDescription: "Inscrivez-vous pour configurer votre page d'accueil",
    FirstName: "Prénom",
    LastName: "Nom de famille",
    Password: "Mot de passe",
    PasswordConfirm: "Confirmer le Mot de Passe",
    SignUpError:
      "Une erreur est survenue lors de votre inscription, veuillez réessayer ou contacter le support.",
    PasswordMismatch: "Les mots de passe ne correspondent pas",
    PasswordLength: "Le mot de passe doit contenir au moins 8 caractères",
    PasswordRequired: "Mot de passe requis",
    InvalidEmail: "Email invalide",
    EmailRequired: "Email requis",
    LastNameRequired: "Nom de famille requis",
    FirstNameRequired: "Prénom requis",
    AccountIdMissing:
      "ID de compte manquant. Veuillez utiliser le lien fourni ou contacter le support.",
    SigningUp: "Inscription",
    PleaseVerifyBeforeContinuing:
      "Inscription réussie. Veuillez vérifier votre email avant de continuer pour vous connecter.",
    SigningIn: "Connexion",
    SignIn: "Se Connecter",
    SignInDescription: "Connectez-vous à votre compte",
    ErrorTitle: "Page d'Erreur",
    ErrorMessage:
      "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard. Si l'erreur persiste, contactez l'assistance.",
    ErrorEmail: "Contactez le support pour des retours.",
    ErrorMessage600:
      "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard. Si l'erreur persiste, contactez l'assistance.",
    ErrorMessage1001:
      "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard. Si l'erreur persiste, contactez l'assistance.",
    ErrorMessage1002:
      "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard. Si l'erreur persiste, contactez l'assistance.",
    ErrorMessage1003:
      "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard. Si l'erreur persiste, contactez l'assistance.",
    GoLoginPage: "Se connecter",
    VerifyTitle: "Vérification de Votre Email",
    SuccessMessageVerifyEmail: "Votre email a été vérifié.",
    VerifyEmail:
      "Si vous ne vous êtes pas inscrit, veuillez contacter le support.",
    ResetPasswordError:
      "Une erreur est survenue lors de la réinitialisation de votre mot de passe, veuillez réessayer ou contacter le support.",
    ResetYourPassword: "Réinitialisez Votre Mot de Passe",
    ResettingPassword: "Réinitialisation du Mot de Passe",
    ResetPasswordDescription: "Réinitialisez votre mot de passe.",
    ResetPasswordSuccess: "Votre mot de passe a été réinitialisé.",
    ForgotPasswordDescription:
      "Mot de passe oublié ? Pas de soucis, nous pouvons vous aider à le réinitialiser.",
    ForgotPasswordError:
      "Une erreur est survenue lors de l'envoi de l'email de réinitialisation, veuillez réessayer ou contacter le support.",
    ForgotPasswordSuccess:
      "Un email vous a été envoyé avec un lien de réinitialisation.",
    SelectTemplate: "Sélectionner un Modèle",
    Personal: "Personnel",
    RealEstateText: "Immobilier",
    Shop: "Boutique",
    Restaurant: "Restaurant",
    AppointmentText: "Rendez-vous",
    Next: "Suivant",
    FailedSeoMessage:
      "Votre nom d'utilisateur est déjà pris, veuillez inclure plus d'informations pour le rendre unique.",
    Crop: "Recadrer",
    Customize: "Personnaliser",
    Button: "Bouton",
    BackgroundColor: "Couleur d'arrière-plan",
    ApplyColors: "Appliquer les couleurs",
    TextColor: "Couleur du texte",
  },
  it: {
    EditWebsite: "Modifica il link del sito web",
    About: "Informazioni",
    Headline: "Titolo/Posizione",
    WebsiteLink: "Link del sito web",
    WebsiteURL: "URL del sito web",
    AboutUs: "Chi siamo",
    Phonenumber: "Numero di telefono",
    Email: "Email",
    Location: "Posizione",
    DOB: "Data di nascita",
    Username: "Nome utente",
    CompanySloganTitle: "Titolo dello slogan dell'azienda",
    Instagram: "Inserisci il nome utente di Instagram",
    WhatsApp: "Inserisci il numero di WhatsApp",
    Facebook: "Inserisci il link di Facebook",
    TikTok: "Inserisci il nome utente di TikTok",
    Youtube: "Inserisci il link di YouTube",
    XTwitter: "Inserisci il link di X/Twitter",
    LinkedIn: "Inserisci il link di LinkedIn",
    Xing: "Inserisci il link di Xing",
    CustomLink: "Inserisci un link personalizzato",
    UpdateProfile: "Aggiorna profilo",
    SuccesMessage: "Profilo salvato con successo",
    FailedMessage: "Impossibile salvare il profilo",
    Close: "Chiudi",
    Save: "Salva",
    Cancel: "Annulla",
    Info: "Informazioni",
    Assistance:
      "Hai bisogno di ulteriore assistenza? Possiamo aiutarti. Inviaci un'email a ",
    OrderInfo: "con il tuo numero d'ordine e lo faremo per te.",
    InstagramInfo:
      "Digita il tuo nome utente di Instagram nell'area di testo fornita.",
    WhatsAppInfo:
      "Digita il tuo numero di telefono WhatsApp nell'area di testo fornita.",
    FacebookInfo:
      "Non sai come creare il tuo link sociale di Facebook? Possiamo aiutarti. Inviaci un'email a ",
    TikTokInfo:
      "Digita il tuo nome utente di TikTok nell'area di testo fornita.",
    YoutubeInfo: "Digita il tuo nome di YouTube nell'area di testo fornita.",
    XTwitterInfo: "Digita il tuo nome utente di X nell'area di testo fornita.",
    LinkedInInfo:
      "Digita il tuo nome utente di LinkedIn nell'area di testo fornita.",
    XingInfo: "Digita il tuo nome utente di Xing nell'area di testo fornita.",
    CustomLinkInfo:
      "Aggiungi altri link social dove le persone possono trovarti qui.",
    Example: "Esempio: 49123456789",
    CountryCode: "Assicurati di includere il prefisso internazionale.",
    NumberFormat: "Il tuo numero non deve includere spazi o trattini.",
    MoreInformation:
      "Possiamo aiutarti con ulteriori informazioni. Inviaci un'email a",
    ERROR_MESSAGE_URL: "Per favore, inserisci un URL valido",
    ERROR_MESSAGE_EMAIL: "Per favore, inserisci un indirizzo email valido",
    ERROR_MESSAGE_PHONE:
      "Per favore, inserisci un numero di telefono valido nel formato +123 456 7890",
    ALERT_MESSAGE: "La dimensione dell'immagine deve essere entro i 10MB.",
    ALERT_MESSAGE_SIZE:
      "Le dimensioni dell'immagine devono essere entro i 500x500 pixel.",
    ALERT_MESSAGE_FILE_SIZE:
      "La dimensione dell'immagine deve essere entro i 10MB.",
    UPLOAD_IMAGE: "Per favore, carica un file immagine.",
    instagram: "Per favore, inserisci un nome utente valido per Instagram",
    whatsapp: "Per favore, inserisci un numero di telefono valido per WhatsApp",
    tiktok: "Per favore, inserisci un nome utente valido per TikTok",
    youtube: "Per favore, inserisci un canale valido per YouTube",
    xtwitter: "Per favore, inserisci un nome utente valido per X",
    linkedin: "Per favore, inserisci un nome utente valido per LinkedIn",
    xing: "Per favore, inserisci un nome utente valido per Xing",
    ToTheShop: "Al negozio",
    ShopLink: "Link del negozio",
    CouponCode: "Inserisci il codice coupon",
    ShopURL: "Inserisci l'URL del negozio",
    ReviewUs: "Valutaci",
    OpinionMatters: "La tua opinione conta",
    GoogleReview: "Link di recensione Google",
    Google: "Inserisci il link di recensione Google",
    TrustPilot: "Inserisci il link di recensione TrustPilot",
    eKomi: "Inserisci il link di recensione eKomi",
    TripAdvisor: "Inserisci il link di recensione TripAdvisor",
    Yelp: "Inserisci il link di recensione Yelp!",
    Feedback: "Inserisci il link di recensione Feedback",
    Followus: "Seguici",
    Getintouch: "Contattaci",
    TrustPilotreview: "Link di recensione Trustpilot",
    EkomiReview: "Link di recensione eKomi",
    TripAdvisor: "Link di recensione TripAdvisor",
    YelpReview: "Link di recensione Yelp!",
    FeedbackReview: "Link di recensione Feedback",
    InstagramUsername: "Nome utente di Instagram",
    WhatsAppLink: "Link di WhatsApp",
    FacebookLink: "Link di Facebook",
    TiktokUsername: "Nome utente di TikTok",
    Youtubechannel: "Canale YouTube",
    XUsername: "Nome utente di X",
    LinkedInLink: "Link di LinkedIn",
    XingLink: "Link di Xing",
    CustomLink: "Link personalizzato",
    CouponDescription:
      "Dai ai tuoi clienti un codice coupon che possono usare al momento del pagamento.",
    ReviewInfo: "Non sai come creare il tuo",
    ReviewInfo2: "link di recensione? Possiamo aiutarti. Inviaci un'email a",
    Menu: "Menu",
    Menulink: "Link del menu",
    MenuURl: "Inserisci l'URL del menu",
    RealEstate: "Scopri il settore immobiliare",
    Properties: "Link delle proprietà",
    PropertiesURL: "Inserisci l'URL delle proprietà",
    Appointment: "Prendi un appuntamento",
    Appointmenttitle: "Link dell'appuntamento",
    AppointmentURL: "URL dell'appuntamento",
    ViewWebSite: "Vedi il sito web",
    SaveContact: "Salva il contatto",
    ShareProfile: "Condividi il profilo",
    URLCopied: "URL copiato negli appunti",
    ProfileURL: "L'URL del profilo è stato copiato negli appunti.",
    ShareIt: "Puoi anche condividerlo tramite:",
    CopyURL: "Copia l'URL",
    Logout: "Disconnettersi",
    SignUp: "Registrati",
    SignUpDescription:
      "Registrati per configurare la tua pagina di destinazione",
    FirstName: "Nome",
    LastName: "Cognome",
    Password: "Password",
    PasswordConfirm: "Conferma Password",
    SignUpError:
      "Si è verificato un errore durante la registrazione, per favore riprova o contatta il supporto.",
    PasswordMismatch: "Le password non corrispondono",
    PasswordLength: "La password deve contenere almeno 8 caratteri",
    PasswordRequired: "Password obbligatoria",
    InvalidEmail: "Email non valida",
    EmailRequired: "Email obbligatoria",
    LastNameRequired: "Cognome obbligatorio",
    FirstNameRequired: "Nome obbligatorio",
    AccountIdMissing:
      "ID account mancante. Si prega di utilizzare il link fornito o contattare il supporto.",
    SigningUp: "Registrazione in corso",
    PleaseVerifyBeforeContinuing:
      "Registrazione avvenuta con successo. Verifica la tua email prima di continuare ad accedere.",
    SigningIn: "Accesso in corso",
    SignIn: "Accedi",
    SignInDescription: "Accedi al tuo account",
    ErrorTitle: "Pagina di Errore",
    ErrorMessage:
      "Si è verificato un errore durante l'elaborazione della richiesta. Riprova più tardi. Se l'errore persiste, contatta l'assistenza.",
    ErrorEmail: "Contatta l'assistenza per feedback.",
    ErrorMessage600:
      "Si è verificato un errore durante l'elaborazione della richiesta. Riprova più tardi. Se l'errore persiste, contatta l'assistenza.",
    ErrorMessage1001:
      "Si è verificato un errore durante l'elaborazione della richiesta. Riprova più tardi. Se l'errore persiste, contatta l'assistenza.",
    ErrorMessage1002:
      "Si è verificato un errore durante l'elaborazione della richiesta. Riprova più tardi. Se l'errore persiste, contatta l'assistenza.",
    ErrorMessage1003:
      "Si è verificato un errore durante l'elaborazione della richiesta. Riprova più tardi. Se l'errore persiste, contatta l'assistenza.",
    GoLoginPage: "Login",
    VerifyTitle: "Verifica Email",
    SuccessMessageVerifyEmail: "La tua email è stata verificata.",
    VerifyEmail: "Se non ti sei registrato, contatta il supporto.",
    ResetPasswordError:
      "Si è verificato un errore durante il reset della password, riprova o contatta il supporto.",
    ResetYourPassword: "Reimposta la Tua Password",
    ResettingPassword: "Reimpostazione Password",
    ResetPasswordDescription: "Reimposta la tua password.",
    ResetPasswordSuccess: "La tua password è stata reimpostata.",
    ForgotPasswordDescription:
      "Hai dimenticato la password? Non ti preoccupare, possiamo aiutarti a reimpostarla.",
    ForgotPasswordError:
      "Si è verificato un errore nell'invio dell'email per il reset della password, riprova o contatta il supporto.",
    ForgotPasswordSuccess:
      "Ti è stata inviata un'email con un link per il reset.",
    SelectTemplate: "Seleziona Modello",
    Personal: "Personale",
    RealEstateText: "Immobiliare",
    Shop: "Negozio",
    Restaurant: "Ristorante",
    AppointmentText: "Appuntamento",
    Next: "Avanti",
    FailedSeoMessage:
      "Il tuo nome utente è già in uso, per favore aggiungi più informazioni per renderlo unico.",
    Crop: "Ritaglia",
    Customize: "Personalizzare",
    Button: "Pulsante",
    BackgroundColor: "Couleur d'arrière-plan",
    ApplyColors: "Applica colori",
    TextColor: "Colore del testo",
  },
  deu: {
    EditWebsite: "Webseiten Link bearbeiten",
    About: "Über",
    Headline: "Titel / Position",
    WebsiteLink: "Link zur Website",
    WebsiteURL: "Webeseiten URL",
    AboutUs: "Über uns",
    Phonenumber: "Telefonnummer",
    Email: "E-Mail",
    Location: "Ort",
    DOB: "Geburtsdatum",
    Username: "Nutzername",
    CompanySloganTitle: "Firmen Slogan",
    Instagram: "Instagram Nutzernamen eingeben",
    WhatsApp: "WhatsApp Nummer eingeben",
    Facebook: "Facebook Profil Link eingeben",
    TikTok: "TikTok Nutzernamen eingeben",
    Youtube: "Youtube Link eingeben",
    XTwitter: "X/Twitter Link eingeben",
    LinkedIn: "LinkedIn Link eingeben",
    Xing: "Xing Link eingeben",
    CustomLink: "Individueller Link",
    UpdateProfile: "Profil aktualisieren",
    SuccesMessage: "Profil erfolgreich aktualisiert.",
    FailedMessage: "Profil konnte nicht gespeichert werden.",
    Close: "Schließen",
    Save: "Speichern",
    Cancel: "Abbrechen",
    Info: "Info",
    Assistance: "Benötigst Du weitere Hilfe? Sende uns bitte eine Mail an",
    OrderInfo: "mit Deiner Bestellnummer und wir übernehmen es gerne für Dich!",
    InstagramInfo:
      "Bitte gebe Deinen Instagram Nutzernamen in dem Textfeld ein.",
    WhatsAppInfo:
      "Bitte gebe Deine WhatsApp Telefonnummer in dem Textfeld ein.",
    FacebookInfo:
      "Du weißt nicht, wie Du deinen Facebook Link erstellst? Wir helfen Dir gerne. Sende uns eine E-Mail an",
    TikTokInfo: "Bitte gebe Deinen TikTok Nutzernamen in dem Textfeld ein.",
    YoutubeInfo: "Bitte gebe Deinen Youtube Nutzernamen in dem Textfeld ein.",
    XTwitterInfo:
      "Bitte gebe Deinen X / Twitter Nutzernamen in dem Textfeld ein.",
    LinkedInInfo: "Bitte gebe Deinen LinkedIN Nutzernamen in dem Textfeld ein.",
    XingInfo: "Bitte gebe Deinen Xing Nutzernamen in dem Textfeld ein.",
    CustomLinkInfo: "Füge weitere Deiner Social Media Links hinzu",
    Example: "Beispiel: 49123456789",
    CountryCode:
      "Bitte denke daran, die richtige Ländervorwahl zu ergänzen (49 in Deutschland).",
    NumberFormat:
      "Deine Nummer darf keine Leerzeichen oder Trennstriche beinhalten.",
    MoreInformation:
      "Wir können Dir gerne weiterhelfen. Sende uns hierzu eine E-Mail.",
    ERROR_MESSAGE_URL: "Bitte gebe eine gültige URL ein.",
    ERROR_MESSAGE_EMAIL: "Bitte gebe eine gültige E-Mail ein.",
    ERROR_MESSAGE_PHONE:
      "Bitte gebe eine gültige Nummer im Format +49908899 ein.",
    ALERT_MESSAGE: "Die Bildgröße darf 10MB nicht übersteigen.",
    ALERT_MESSAGE_SIZE:
      "Die Bildabmessungen sollten 500x500 Pixel nicht übersteigen",
    ALERT_MESSAGE_FILE_SIZE: "Die Bildgröße darf 10MB nicht übersteigen.",
    UPLOAD_IMAGE: "Bitte lade ein Bild hoch.",
    instagram: "Bitte geben einen gültigen Nutzernamen an.",
    whatsapp: "Bitte gebe eine gültige WhatsApp Nummer an",
    tiktok: "Bitte geben einen gültigen Nutzernamen an.",
    youtube: "Bitte geben einen gültigen Youtube Channel an.",
    xtwitter: "Bitte geben einen gültigen Nutzernamen an.",
    linkedin: "Bitte geben einen gültigen Nutzernamen an.",
    xing: "Bitte geben einen gültigen Nutzernamen an.",
    ToTheShop: "Zum Shop",
    ShopLink: "Shop Link",
    CouponCode: "Gebe einen Gutscheincode ein.",
    ShopURL: "Gebe den Link zu Deinem Shop an.",
    ReviewUs: "Bewerte uns",
    OpinionMatters: "Deine Meinnung zählt",
    GoogleReview: "Google Bewertungslink",
    Google: "Gebe den Google Bewertungslink ein.",
    TrustPilot: "Gebe den TrustPilot Bewertungslink ein.",
    eKomi: "Gebe den ekomi Bewertungslink ein.",
    TripAdvisor: "Gebe den TripAdvisorBewertungslink ein.",
    Yelp: "Gebe den Yelp! Bewertungslink ein.",
    Feedback: "Gebe deinen individuellen Bewertungslink ein.",
    Followus: "Folge uns",
    Getintouch: "Get in touch",
    TrustPilotreview: "Trustpilot Bewertungslink",
    EkomiReview: "ekomi Bewertungslink",
    TripAdvisor: "TripAdvisor Bewertungslink",
    YelpReview: "Yelp! Bewertungslink",
    FeedbackReview: "Individueller Link",
    InstagramUsername: "Instagram Nutzername",
    WhatsAppLink: "WhatApp Nummer",
    FacebookLink: "Facebook Link",
    TiktokUsername: "TikTok Nutzername",
    Youtubechannel: "YouTube Channel",
    XUsername: "X Nutzername",
    LinkedInLink: "LinkedIn Link ",
    XingLink: "Xing Link",
    CustomLink: "Individueller Link",
    CouponDescription:
      "Gebe Deinen Kund:innen einen Gutscheincode für Deinen Shop",
    ReviewInfo: "Du weißt nicht, wie Du deinen",
    ReviewInfo2:
      "Bewertungs-Link erstellst? Wir helfen Dir gerne. Sende uns eine E-Mail an ",
    Menu: "Speisekarte",
    Menulink: "Link zur Speisekarte",
    MenuURl: "Gebe die URL zur Speisekarte ein",
    RealEstate: "Entdecke unsere Immobilienangebote",
    Properties: "Link zu den Immobilienangeboten",
    PropertiesURL: "Gebe den Link zur den Immobilienangeboten an.",
    Appointment: "Termin vereinbaren",
    Appointmenttitle: "Link zur Terminvereinbarung",
    AppointmentURL: "Link zur Terminvereinbarung",
    ViewWebSite: "Zur Website",
    SaveContact: "Kontakt speichern",
    ShareProfile: "Profil teilen",
    URLCopied: "Profil URL wurde zu Deiner Zwischenablage kopiert",
    ProfileURL: "Profil URL wurde zu Deiner Zwischenablage kopiert",
    ShareIt: "Du kannst es auch teilen via:",
    CopyURL: "URL kopieren",
    MaximumCharacter: "Die maximale Anzahl an Zeichen für",
    Is: "ist",
    Characters: "Zeichen.",
    ChooseLanguage: "Wählen Sie Ihre Sprache",
    FailedURL: "URL konnte nicht kopiert werden.",
    MaximumCharacter: "Die maximale Anzahl an Zeichen für",
    Logout: "Ausloggen",
    SignUp: "Registrieren",
    SignUpDescription:
      "Registrieren Sie sich, um Ihre Landingpage zu konfigurieren",
    FirstName: "Vorname",
    LastName: "Nachname",
    Password: "Passwort",
    PasswordConfirm: "Passwort Bestätigen",
    SignUpError:
      "Es gab einen Fehler bei der Registrierung, bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    PasswordMismatch: "Passwörter stimmen nicht überein",
    PasswordLength: "Passwort muss mindestens 8 Zeichen lang sein",
    PasswordRequired: "Passwort ist erforderlich",
    InvalidEmail: "Ungültige E-Mail",
    EmailRequired: "E-Mail ist erforderlich",
    LastNameRequired: "Nachname ist erforderlich",
    FirstNameRequired: "Vorname ist erforderlich",
    AccountIdMissing:
      "Kontonummer fehlt. Bitte verwenden Sie den bereitgestellten Link oder kontaktieren Sie den Support.",
    SigningUp: "Registrierung",
    PleaseVerifyBeforeContinuing:
      "Registrierung erfolgreich. Bitte überprüfen Sie Ihre E-Mail, bevor Sie sich anmelden.",
    SigningIn: "Anmeldung",
    SignIn: "Anmelden",
    SignInDescription: "Melden Sie sich bei Ihrem Konto an",
    ErrorTitle: "Fehlerseite",
    ErrorMessage:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorEmail: "Kontaktieren Sie den Support für Feedback.",
    ErrorMessage600:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorMessage1001:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorMessage1002:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    ErrorMessage1003:
      "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal. Wenden Sie sich an den Support, wenn der Fehler weiterhin besteht.",
    GoLoginPage: "Ausloggen",
    VerifyTitle: "Ihre E-Mail-Verifizierung",
    SuccessMessageVerifyEmail: "Ihre E-Mail wurde verifiziert.",
    VerifyEmail:
      "Wenn Sie sich nicht registriert haben, kontaktieren Sie bitte den Support.",
    ResetPasswordError:
      "Fehler beim Zurücksetzen Ihres Passworts, bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    ResetYourPassword: "Setzen Sie Ihr Passwort Zurück",
    ResettingPassword: "Passwort wird Zurückgesetzt",
    ResetPasswordDescription: "Setzen Sie Ihr Passwort zurück.",
    ResetPasswordSuccess: "Ihr Passwort wurde zurückgesetzt.",
    ForgotPasswordDescription:
      "Passwort vergessen? Keine Sorge, wir helfen Ihnen beim Zurücksetzen.",
    ForgotPasswordError:
      "Fehler beim Senden der Passwort-Reset-E-Mail, bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    ForgotPasswordSuccess:
      "Eine E-Mail mit einem Reset-Link wurde an Sie gesendet.",
    SelectTemplate: "Vorlage Auswählen",
    Personal: "Persönlich",
    RealEstateText: "Immobilien",
    Shop: "Geschäft",
    Restaurant: "Restaurant",
    AppointmentText: "Termin",
    Next: "Weiter",
    FailedSeoMessage:
      "Ihr Benutzername ist bereits vergeben, bitte fügen Sie weitere Informationen hinzu, um ihn einzigartig zu machen.",
    Crop: "Zuschneiden",
    Customize: "Anpassen",
    Button: "Taste",
    BackgroundColor: "Hintergrundfarbe",
    ApplyColors: "Farben anwenden",
    TextColor: "Textfarbe",
  },

  // Add more languages here
};

export default translations;
